import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by MIL"
      links={[
        {
          key: 'Exceptional Brands',
          title: 'Exceptional Brands',
          href: 'https://qr-landing.microvision.co.ke/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
